"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { Phone, ShieldCheck, Wrench } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeavyDutySolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="122906" id="commercial-power-partners" className="dark relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background text-foreground border-b border-border">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-background/85 backdrop-blur-[1px] z-10"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-transparent to-background z-10"></div>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603327/img/semi_truck_wheel_grunge.png" alt="Commercial electrical infrastructure" className="w-full h-full object-cover opacity-40 grayscale mix-blend-multiply dark:mix-blend-overlay" />
      </div>

      {}
      <div className="absolute top-6 right-[-20px] md:top-10 md:right-10 z-30 transform rotate-45 md:rotate-3">
        <Badge className="bg-destructive text-destructive-foreground text-xs md:text-sm font-bold uppercase tracking-widest py-2 px-8 md:px-4 shadow-2xl border-2 border-destructive-foreground/10 rounded-sm">
          24/7 Emergency Service
        </Badge>
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 md:px-6 text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="inline-flex items-center justify-center p-4 rounded-full bg-primary/10 backdrop-blur-md mb-8 border border-primary/20 shadow-lg shadow-primary/5">
          <Wrench className="size-8 md:size-10 text-primary" />
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tight uppercase text-white leading-[1.1] mb-6 drop-shadow-md">
          Commercial <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400 drop-shadow-[0_0_25px_rgba(59,130,246,0.4)]">
            Power Partners
          </span>
        </h1>

        <p className="text-lg md:text-2xl text-muted-foreground max-w-3xl mx-auto mb-10 font-medium tracking-wide">Humberg Electrical Services delivers precision industrial solutions and safety compliance across Richmond, Sugar Land, Missouri City, and the Houston area. Our family-owned team ensures your facility stays powered 24/7.</p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full sm:w-auto">
          <Button size="lg" className="w-full sm:w-auto text-base md:text-lg h-14 px-8 font-bold uppercase tracking-widest shadow-2xl bg-destructive hover:bg-destructive/90 hover:scale-105 transition-all rounded-sm" asChild>
            <Link to="tel:8324053766">
              <Phone className="mr-2 size-5" />
              Call (832) 405-3766
            </Link>
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto text-base md:text-lg h-14 px-8 font-bold uppercase tracking-widest border-2 border-primary/50 text-white bg-background/30 backdrop-blur-sm hover:bg-primary/10 rounded-sm" asChild>
            
          </Button>
        </div>

        {}
        <div className="mt-16 flex flex-wrap justify-center gap-6 md:gap-12 text-xs md:text-sm font-bold text-muted-foreground uppercase tracking-[0.2em]">
          <div className="flex items-center gap-2">
            <ShieldCheck className="size-5 text-primary" />
            <span>Safety Compliance</span>
          </div>
          <div className="flex items-center gap-2">
            <ShieldCheck className="size-5 text-primary" />
            <span>24/7 Emergency Calls</span>
          </div>
          <div className="flex items-center gap-2">
            <ShieldCheck className="size-5 text-primary" />
            <span>Family Owned & Operated</span>
          </div>
        </div>
      </div>
    </section>;
}